var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6.5 4.5l3 3-3 3","stroke":"#000"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }